import React, { Suspense } from 'react'
import styled from 'styled-components'
import { Modal } from 'components/common/modal'
import { useStartupUser } from 'apis/hooks'
import {
  BaseText,
  H5Text,
  SemiBoldText,
  SmallText,
} from 'components/common/text'
import { Column } from 'components/common/layout'
import { useStores } from 'stores/globals'
import { observer } from 'mobx-react'

export const BanReasonNoticeModal: React.FC = observer(() => {
  const { loginStore } = useStores()
  const { data: user } = useStartupUser()

  if (loginStore.isFake || !user?.banReason) return null // fakeLogin일 경우, banReason이 없을 경우(이용정지 제제받지 않은 경우) 모달을 띄우지 않음
  return (
    <Suspense>
      <Content banReason={user.banReason} />
    </Suspense>
  )
})

const Content: React.FC<{
  banReason: string
}> = observer(({ banReason }) => {
  return (
    <Modal width={537} disableCloseBtn disableBackgroundClick>
      <Container>
        <MainText>
          🚫
          <br /> 서비스 이용이 일시 정지되었습니다.
        </MainText>
        <Column
          style={{
            gap: 8,
          }}
        >
          <SectionTitleText>정지 사유</SectionTitleText>
          <BanReasonBackground>
            <BanReasonText>{banReason}</BanReasonText>
          </BanReasonBackground>
        </Column>
        <SubText>
          자세한 안내와 서비스 이용 재개를 희망하시면
          <br />
          support@groupby.biz 이메일이나{' '}
          <u>
            <b>
              <a href='https://groupbycs.channel.io/workflows/47107'>채널톡</a>
            </b>
          </u>
          으로 문의해주세요.
          <br />
          (응답시간 : 월~금, 오전 9~6시)
        </SubText>
      </Container>
    </Modal>
  )
})

const Container = styled(Column)`
  position: relative;
  gap: 32px;
  padding: 20px;
  text-align: center;
`

const MainText = styled(SemiBoldText)`
  font-size: ${(p) => p.theme.fontSize.h2};
`

const SectionTitleText = styled(H5Text)`
  font-weight: ${(p) => p.theme.fontWeight.semiBold};
`

const BanReasonText = styled(BaseText)`
  font-weight: ${(p) => p.theme.fontWeight.medium};
  line-height: 24px;
  word-break: keep-all;
`

const BanReasonBackground = styled.div`
  padding: 24px;
  border-radius: 12px;
  background-color: #ffdcdc;
`

const SubText = styled(SmallText)`
  color: ${(p) => p.theme.color.black2};
  font-size: ${(p) => p.theme.fontSize.small};
  line-height: 18px;
`
